/**
 * Agent Module
 */
const getDefaultState = () => {
  return {
    preiviewLayout: false,
    addCardMode: false,
    selectedOrder: null,
    agentId: '',
    templateList: [],
    templateId: '',
    templateTitle: '',
    templateContent: [{
      templateType: '',
      order: '',
      content: {
        title: '',
        description: '',
        imageUrl: '',
        imageLink: '',
        button: []
      }
    }]
  }
}
const state = getDefaultState()

const getters = {
  marketingLineTemplateId: (state) => {
    return state.templateId
  },
  marketingLineAgentId: (state) => {
    return state.agentId
  },
  marketingLineTemplateTitle: (state) => {
    return state.templateTitle
  },
  marketingLineTemplateContent: (state) => {
    state.templateContent.sort((s1, s2) => s1.order - s2.order)
    state.templateContent.forEach((data, index) => {
      data.order = index
    })
    return state.templateContent
  },
  marketingLineTemplateContentLength: (state) => {
    return state.templateContent.length
  },
  marketingLineTemplateContentTitle: (state) => {
    return state.templateContent.content.title
  },
  marketingLineTemplateContentDescription: (state) => {
    return state.templateContent.content.description
  },
  marketingLineTemplateContentImage: (state) => {
    return state.templateContent.content.imageUrl
  },
  marketingLineTemplateList: (state) => {
    return state.templateList
  },
  marketingLineTemplateContentType: (state) => {
    return state.templateContent.templateType
  },
  marketingLinePreiviewLayout: (state) => {
    return state.preiviewLayout
  },
  marketingLineAddCardMode: (state) => {
    return state.addCardMode
  },
  marketingLineTemplateButton (state) {
    return state.templateContent.content.button
  },
  marketingLineTemplateTypeList (state) {
    return state.templateContent.map(list => list.templateType)
  },
  marketingLineSelectedOrder (state) {
    return state.selectedOrder
  },
  isMarketingButtonCheck (state) {
    let btnArray = state.templateContent.map((data) => {
      return data.content.button
    })
    let lengthCheck = btnArray.every((data, index, arr) => {
      const check = data.length === arr[0].length
      return check
    })
    return lengthCheck
  }
}

const actions = {
}

const mutations = {
  resetmarketingLineTemplate (state) {
    Object.assign(state, getDefaultState())
  },
  setMarketingLineTemplate (state, data) {
    state.templateContent[state.selectedOrder].content.button.push(data)
  },
  addLineTitleTemplate (state, data) {
    state.templateContent[state.selectedOrder].content.title = data
  },
  addLineDescriptionTemplate (state, data) {
    state.templateContent[state.selectedOrder].content.description = data
  },
  addLineImageLinkUrlTemplate (state, data) {
    state.templateContent[state.selectedOrder].content.imageUrl = data.imageUrl
    state.templateContent[state.selectedOrder].content.imageLink = data.imageLink
    state.templateContent[state.selectedOrder].content.imageName = data.imageName
  },
  addLineImageUrlTemplate (state, data) {
    state.templateContent[state.selectedOrder].content.imageUrl = data
  },
  addLineCardTemplate (state) {
    let data = state.templateContent[state.selectedOrder]
    let copyBtnData = data.content.button.map((btn) => {
      let copy = {
        'buttonType': btn.buttonType,
        'name': btn.name + '(1)'
      }
      if (btn.buttonType === 'URL_BUTTON') {
        copy.url = btn.url
      } else {
        copy.callNumber = btn.callNumber
      }
      return copy
    })
    let defalutData = {
      templateType: data.templateType,
      order: state.templateContent.length,
      content: {
        title: data.content.title ? data.content.title + '(1)' : '',
        description: data.content.description ? data.content.description + '(1)' : '',
        imageUrl: data.content.imageUrl ? data.content.imageUrl : '',
        imageLink: data.content.imageLink ? data.content.imageLink : '',
        imageName: data.content.imageName ? data.content.imageName : '',
        button: copyBtnData
      }
    }
    state.selectedOrder = ''
    state.templateContent.push(defalutData)
  },
  deleteLineButtonTemplate (state, index) {
    state.templateContent[state.selectedOrder].content.button.splice(index, 1)
  },
  changeLineTemplateType (state, type) {
    state.templateContent.forEach((d) => {
      d.templateType = type
    })
    state.marketingLineSelectedOrder = null
  },
  changeLineTemplateList (state, templateList) {
    state.templateList = templateList
  },
  changeLineTemplateId (state, templateId) {
    state.templateId = templateId
  },
  setLineAgentId (state, agentId) {
    state.agentId = agentId
  },
  selectLineTemplate (state, template) {
    state.templateId = template.marketingId
    state.templateTitle = template.marketingName
  },
  changeLineTemplateView (state, template) {
    state.templateContent = template.marketingTemplateContent
  },
  clearLineTemplateList (state) {
    state.templateList = []
  },
  clearLineTemplateContent (state) {
    let defalutData = [{
      templateType: 'IMAGE_TEXT_BUTTON',
      order: 0,
      content: {
        title: '',
        description: '',
        imageUrl: '',
        imageLink: '',
        button: []
      }
    }]
    state.templateContent = defalutData
  },
  addLineTemplate (state, template) {
    state.templateList.unshift(template)
  },
  deleteLineTemplate (state, template) {
    const templateIndex = state.templateList.map(template => template.marketingId).indexOf(template.marketingId)
    if (templateIndex === -1) {
      return
    }
    state.templateList.splice(templateIndex, 1)
    // if (state.templateList.length > 0) {
    //   this.selectTemplate(state.templateList[0])
    // } else {
    //   state.selectedScenario = undefined
    // }
  },
  setMarketingLinePreiviewLayout (state) {
    state.preiviewLayout = true
  },
  setMarketingLineAddCardMode (state) {
    state.addCardMode = !state.addCardMode
  },
  setMarketingLineSelectedOrder (state, order) {
    state.selectedOrder = order
  },
  deleteMarketingLineSelectedOrder (state, order) {
    state.templateContent.splice(order, 1)
    state.selectedOrder = null
  },
  moveLineTemplate (state, type) {
    if (type === 'RIGHT') {
      state.templateContent[state.selectedOrder].order += 1
      state.templateContent[state.selectedOrder + 1].order -= 1
    } else if (type === 'LEFT') {
      state.templateContent[state.selectedOrder].order -= 1
      state.templateContent[state.selectedOrder - 1].order += 1
    } else if (type === 'MAX_RIGHT') {
      state.templateContent[state.selectedOrder].order = state.templateContent.length + 1
    } else if (type === 'MAX_LEFT') {
      state.templateContent[state.selectedOrder].order = -1
    }
    state.selectedOrder = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/marketingLine/index.js